<template>
  <div>
    <div>
      <div class="w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px">
        <router-link :to="{ name: 'Payment' }">
          <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
        </router-link>
        <span>
          ชำระเงินด้วยบัตรเครดิต
        </span>
      </div>
      <div class="w-100pct h-60calc">
        <div class="pd-t-23px">
          <img src="/static/img/icons/apple-touch-icon-180x180.png" class="w-78px">
        </div>
        <div class="mg-t-23px f-s-16px f-w-bold">
          <span>ยอดที่ต้องชำระ ฿ {{ netPrice | showFullPriceFormat() }}</span>
        </div>
        <div class="mg-t-23px f-s-16px f-w-bold">
          <div class="checkout-btn cs-pointer mg-auto pd-8px" @click="finishCheckout('Credit')"> ชำระเงินเสร็จสิ้น </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="activeModal" :canCancel="[]">
      <SelectPrinter/>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectPrinter from './components/SelectPrinter'

export default {
  name: 'checkout-by-cash',
  components: {
    SelectPrinter
  },
  data () {
    return {
      activeModal: false
    }
  },
  methods: {
    ...mapActions([
      'checkout',
      'setIsloading',
      'fetchPrinters'
    ]),
    async finishCheckout (paymentType) {
      this.setIsloading(true)
      await this.checkout(paymentType)
      this.setIsloading(false)
      this.activeModal = true
    }
  },
  computed: {
    ...mapGetters({
      netPrice: 'getNetPrice',
      fullPrice: 'getFullPrice'
    })
  },
  async mounted () {
    await this.fetchPrinters()
  }
}
</script>

<style scoped>
.checkout-btn {
  width: 160px;
  height: 36px;
  border-radius: 4px;
  background-color: #000000;
  border: solid 1px #e5e5e5;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/check-out/CheckoutByCard.vue